import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordService {
    private readonly http = inject(HttpClient);

    forgotPassword(email: string): Observable<void> {
        return this.http.post<void>(`${environment.config.api_url}Auth/ForgotPassword`, { email });
    }
}
